import VModal from './VModal.vue'

/**
 * Bus de eventos para comunicação entre o plugin e os componentes <modal>.
 * Exportado para ser importado pelo VModal.vue.
 */
export const modalBus = {
  _listeners: {},

  on (event, cb) {
    if (!this._listeners[event]) this._listeners[event] = []
    this._listeners[event].push(cb)
  },

  off (event, cb) {
    if (!this._listeners[event]) return
    this._listeners[event] = this._listeners[event].filter(fn => fn !== cb)
  },

  emit(event, ...args) {
    // eslint-disable-next-line no-extra-semi
    ;(this._listeners[event] || []).forEach((cb) => cb(...args))
  }
}

/**
 * Plugin de modal puro (sem dependências externas) para Vue 3.
 */
export const ModalPlugin = {
  install (app) {
    const $modal = {
      show (name, params = {}) {
        modalBus.emit(`modal:show:${name}`, params)
      },
      hide (name) {
        modalBus.emit(`modal:hide:${name}`)
      }
    }

    app.config.globalProperties.$modal = $modal
    app.component('LegacyModal', VModal)
  }
}
